import React, { Component, ReactNode } from 'react';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import { locale } from '../../common/localization/localizationService';
import CommandCell from '../userAdmin/CommandCell';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

export interface IVehicleSettingsGridProps {
  data: any;
  editVehicleSetting: (dataItem: any) => void;
  deleteVehicleSetting: (dataItem: any) => void;
  className?: string;
}

export interface IVehicleSettingsGridState {
  dataState: Record<string, any>;
}

export class VehicleSettingsGrid extends Component<
  IVehicleSettingsGridProps,
  IVehicleSettingsGridState
> {
  public readonly state: IVehicleSettingsGridState = {
    dataState: {
      sort: [
        {
          dir: 'asc',
          field: 'key',
        },
      ],
    },
  };

  public dataStateChange(event: Record<string, any>): void {
    this.setState({ ...this.state, dataState: event.data });
  }

  private EditCell(props: any) {
    return (
      <CommandCell
        {...props}
        edit={this.props.editVehicleSetting}
        icon={faEdit}
      />
    );
  }

  private DeleteCell(props: any) {
    return (
      <CommandCell
        {...props}
        edit={this.props.deleteVehicleSetting}
        icon={faTrash}
      />
    );
  }

  public render(): ReactNode {
    const result = process(this.props.data, this.state.dataState);
    const className = this.props.className || '';
    return (
      <Grid
        {...this.state.dataState}
        className={className + ' vehicle-settings-grid'}
        data={result}
        selectedField="selected"
        scrollable={'none'}
        sortable
        onDataStateChange={this.dataStateChange.bind(this)}
      >
        <GridNoRecords>{locale.vehicleSettings._noSettings}</GridNoRecords>
        <GridColumn
          field="key"
          title={locale.vehicleSettings._parameter}
          className="auto-resize-column"
        />
        <GridColumn
          field="value"
          title={locale.vehicleSettings._value}
          className="auto-resize-column"
        />
        <GridColumn
          field="description"
          title={locale.vehicleSettings._description}
          className="auto-resize-column"
        />
        <GridColumn
          cell={this.EditCell.bind(this)}
          width={26}
          sortable={false}
        />
        <GridColumn
          cell={this.DeleteCell.bind(this)}
          width={26}
          sortable={false}
        />
      </Grid>
    );
  }
}

export default VehicleSettingsGrid;
